import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row geolocation" }

import { YMap } from '@yandex/ymaps3-types';
import {
  YandexMap,
  YandexMapControls,
  YandexMapDefaultFeaturesLayer,
  YandexMapDefaultMarker,
  YandexMapDefaultSchemeLayer,
  YandexMapListener,
  YandexMapZoomControl,
} from 'vue-yandex-maps';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { computed, getCurrentInstance, inject, nextTick, ref, shallowRef } from 'vue';

export interface Props extends PropValue<null | [number, number]> {
  readonly?: boolean;
  label: string;
}


export const defaultCoords: [number, number] = [69.02009737214722, 61.002845095776756];

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'GeolocationParameter' },
  __name: 'Geolocation',
  props: {
    readonly: { type: Boolean, default: false },
    label: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emit = __emit;
const { innerValue, emitValue } = useValue(props, emit, {
  transform: (v) => v?.reverse() ?? null,
  mrofsnart: (iv) => iv?.reverse() ?? null,
  checkEquality: true,
});

const center = ref(innerValue.value ?? defaultCoords);

function onDragEnd(newCoordinates) {
  innerValue.value = newCoordinates;
  emitValue();
}

const map = shallowRef<null | YMap>(null);

async function refreshCoords(obj: any, event) {
  innerValue.value = event.coordinates;
  emitValue();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-body1" }, "Пожалуйста укажите на карте точку", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(YandexMap), {
        modelValue: map.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((map).value = $event)),
        settings: {
          location: {
            center: center.value,
            zoom: 12,
            duration: 1000,
          },
        },
        width: "100%",
        height: "500px"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(YandexMapDefaultSchemeLayer)),
          _createVNode(_unref(YandexMapDefaultFeaturesLayer)),
          _createVNode(_unref(YandexMapControls), { settings: { position: 'right' } }, {
            default: _withCtx(() => [
              _createVNode(_unref(YandexMapZoomControl))
            ]),
            _: 1
          }),
          (_unref(innerValue))
            ? (_openBlock(), _createBlock(_unref(YandexMapDefaultMarker), {
                key: 0,
                settings: {
            coordinates: _unref(innerValue),
            draggable: !_ctx.readonly,
            onDragEnd: onDragEnd,
          }
              }, null, 8, ["settings"]))
            : _createCommentVNode("", true),
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_unref(YandexMapListener), {
                key: 1,
                settings: { onClick: refreshCoords }
              }, null, 8, ["settings"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "settings"])
    ])
  ]))
}
}

})